// src/components/services/electricity/Electricity_Bill/Electricity_Bill.js

import { Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import * as animationData from '../../../animations/recharge_card_lottie_animation/Electricity_animation.json';
import Recharge_card_lottie_animation from '../../../animations/recharge_card_lottie_animation/Recharge_card_lottie_animation';
import Common_recharge_page_banner from '../../../common_components/common_banner/common_recharge_page_banner/Common_recharge_page_banner';
import Proceed_btn from '../../../common_components/common_btn/proceed_btn/Proceed_btn';
import All_providers from '../../../common_components/common_cards/all_providers/All_providers';
import Bill_payments from '../../../home/bill_payments/Bill_payments';
import Contribution from '../../../home/contribution/Contribution';
import "./Electricity_Bill.css";

function Electricity_Bill() {
    const navigate = useNavigate();

    const providers = [
        { id: 1, providerName: "Andhra Pradesh Central Power Distribution Corporation Limited", logo: "/assets/images/services/all_providers/electricity_card/Maha.png" },
        { id: 2, providerName: "Andhra Pradesh Central Power Distribution Corporation Limited", logo: "/assets/images/services/all_providers/electricity_card/Maha.png" },
        { id: 3, providerName: "Adani Electricity Mumbai, Maharashtra", logo: "/assets/images/services/all_providers/electricity_card/Adani.png" },
        { id: 4, providerName: "Adani Electricity Mumbai, Maharashtra", logo: "/assets/images/services/all_providers/electricity_card/Adani.png" },
        { id: 5, providerName: "Andhra Pradesh Central Power Distribution Corporation Limited", logo: "/assets/images/services/all_providers/electricity_card/Maha.png" },
        { id: 6, providerName: "Andhra Pradesh Central Power Distribution Corporation Limited", logo: "/assets/images/services/all_providers/electricity_card/Maha.png" },
    ];


    const services = [
        {
            id: 1,
            img: "/assets/images/home/bill_payments/money.png",
            title: "Mobile Recharge",
            baseLink: "/mobile-recharge",
        },
        {
            id: 2,
            img: "/assets/images/home/bill_payments/satellite-dish.png",
            title: "DTH Recharge",
            baseLink: "/dth-recharge",
        },
        {
            id: 4,
            img: "/assets/images/home/bill_payments/gas-stove.png",
            title: "Gas Cylinder",
            baseLink: "/gas-recharge",
        },
        {
            id: 5,
            img: "/assets/images/home/bill_payments/buy-a-car.png",
            title: "FASTag Recharges",
            baseLink: "/fastag-recharge",
        },
    ];

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: { preserveAspectRatio: "xMidYMid slice" }
    };

    const breadcrumbData = [
        { label: "Services", path: "/services", active: false },
        { label: "Electricity Bill", active: true }
    ];

    const options = [
        { value: 'airtel', label: 'Airtel DTH' },
        { value: 'tatasky', label: 'Tata Sky' },
        { value: 'dish', label: 'Dish TV' },
        { value: 'sun', label: 'Sun Direct' }
    ];

    return (
        <>
            <Common_recharge_page_banner
                title="Electricity BILL"
                breadcrumbItems={breadcrumbData}
            />

            <section className="Mobile_Recharge DTH_Recharge Electricity_Bill">
                <div className="container">
                    <div className="Mobile_Recharge_container">
                        <div className="row">
                            <div className="col-md-7">
                                <div className="recharge_form_section form_box_section">
                                    <Form className="recharge_form">
                                        <div className="form_row">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <Form.Group controlId="operator" className="form_field">
                                                        <Form.Label>Provider Name</Form.Label>
                                                        <Select placeholder="Select Provider Name" options={options} />
                                                    </Form.Group>
                                                </div>

                                                <div className="col-md-6">
                                                    <Form.Group controlId="rechargeAmount" className="form_field">
                                                        <Form.Label>Consumer ID</Form.Label>
                                                        <Form.Control
                                                            type="text"
                                                            placeholder="Enter consumer number"
                                                        />
                                                        <Form.Text className="muted_text">
                                                            Please enter a valid 12 digit Consumer No (eg. 000437378053)
                                                        </Form.Text>
                                                    </Form.Group>
                                                </div>

                                                <div className="col-12">
                                                    <div className="btn_holder">
                                                        <Proceed_btn
                                                            btnText="Continue"
                                                            className="save_changes_btn"
                                                            onClick={() => navigate("/electricity-bill-details-plans")}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Form>
                                </div>
                            </div>

                            <div className="col-md-5">
                                <div className="cashback_offer_section form_box_section">
                                    <div className="cashback_box">
                                        <div className="heading_holder">
                                            <div className="cashback_heading">
                                                <h5>SWITCH TO SMARTER </h5>
                                                <h5>BILL PAYMENTS</h5>
                                            </div>
                                            <span className="tnc_text">*T&C Apply</span>
                                        </div>
                                        <p>Get reminders & pay electricity bills on time, every time.</p>
                                    </div>

                                    <div className="recharge_lottie_holder">
                                        <Recharge_card_lottie_animation defaultOptions={defaultOptions} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ✅ Passing providers as props */}
            <All_providers providers={providers} />

            <Bill_payments
                sectionTitle='EXPLORE OUR OTHER SERVICES'
                sectionSubtitle='From recharges to rewards, discover everything we offer in one place'
                services={services}
            />
            <Contribution />
        </>
    );
}
export default Electricity_Bill;
